<template>
	<table class="analysis-grid">
		<thead class="analysis-header">
			<td></td>
			<td>
				<div class="titles">
					<global-svg type="sad"></global-svg>
					<global-svg type="neutral"></global-svg>
					<global-svg type="happy"></global-svg>
				</div>
			</td>
      <td></td>
		</thead>

		<tbody>
			<tr v-for="(item, i) in dataSubset" :key="i">
				<td>
					<span class="title" :class="{'with-icon' : item.icon && item.logo }">
						<img :src="item.icon" v-if="item.icon && item.logo">
						<span class="tag" v-on:click="clickTag(item)">{{ item.name }}</span>
					</span>
				</td>
				<td>
					<article-analysis :show-lines="true" :data="item.sentiment" :mode="item.domain ? 'publisher' : 'topic'"></article-analysis>
				</td>
        <td>
          <span class="count" v-if="item.scores && item.scores['hits-user']">
						<span :title="getCountTitle(item)" class="tag" v-on:click="clickTag(item)">{{ item.scores['hits-user'] }}</span>
					</span>
        </td>
			</tr>

			<tr v-if="!showingMore && data && data.length > modifyLimit">
				<td></td>
				<td>
					<span class="tag show-more" v-on:click="showMoreAnalysis">Show More</span>
				</td>
			</tr>
		</tbody>

	</table>
</template>

<script>
import ArticleAnalysis from 'app/components/ArticleAnalysis';

export default {
	name: 'AnalysisGrid',
	props: {
		data: {},
	},
	components: {
		ArticleAnalysis,
	},
	data() {
		return {
			showingMore: false,
			modifyLimit: 6,
		}
  },
  computed: {
    dataSubset() {
      if (!this.data || !this.data.filter) {
        return [];
      }
      // remove blanks
      let data = this.data.filter(item => item.name);

      return data.filter((item,i) => {
        return (i < this.modifyLimit) && item.sentiment && item.sentiment.scores && item.sentiment.scores.xo;
      });
    }
  },
	methods: {
		showMoreAnalysis() {
			this.modifyLimit = 10000,
			this.showingMore = true
		},
		clickTag(tag) {
			this.$router.push(`/search/?q=${tag.name}`)
			// this.$router.push(`/topic/${tag.code}`)
			// this.$emit("clickedTag", tag);
    },
    getCountTitle(item) {
      let typeClause = item.domain ? 'from this publisher' : 'on this topic';
      return `We have observed you reading ${item.scores['hits-user']} articles ${typeClause}`;
    }
	}
}
</script>



<style lang="scss">
  @import '~styles/_variables';

	.analysis-header {
		.titles {
			display: flex;
			justify-content: space-between;
			.svg-wrapper {
				padding: 0 0.5em;
			}
		}
	}



	.analysis-grid {
		border-collapse: collapse;
		margin-top: 1em;
		position: relative;
		width: 100%;
		td {
			padding: 0 0 0.75em 0;
      width: 100%;
			&:first-of-type {
				width: 30%;
			}
			&:last-of-type {
				width: 50px;
			}
		}
		.article-analysis {
			display: flex;
			align-items: center;
			justify-content: center;
			+ .article-analysis {
				margin-top: 1em;
			}
		}
		.title {
			display: flex;
			align-items: center;
			color: rgb(16, 24, 24);
			font-size: 11px;
			font-weight: 700;
			line-height: 13px;
			text-align: right;
			display: flex;
			justify-content: flex-end;
			height: 30px;
			line-height: 30px;
			cursor: pointer;

			.darkmode & {
				color: $white-primary;
			}
		}

		img {
			height: 23px;
			width: auto;
			border-radius: 50%;
			display: block;
			position: relative;
			z-index: 20;
		}

		.tag {
			text-transform: capitalize;
			color: rgb(16, 24, 24);
			font-size: 14px;
			font-weight: 700;
			font-family: $ff-tag;
			position: relative;
			background: rgb(241, 211, 2);
			padding: 0.4em 1em;
			-webkit-box-align: center;
			-ms-flex-align: center;
			align-items: center;
			border-radius: 50px;
			color: rgb(16, 24, 24);
			cursor: pointer;
			z-index: 2;
			vertical-align: top;

			display: inline-block;
			line-height: 1.4;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			max-width: 160px;
			margin-right: 0.5rem;
			height: 100%;
      
		}
    .count {
      position: relative;
      display: inline-block;
      &::before {
		// @include palette-block;
        position: absolute;
        content: "";
        top: 0;
        bottom: 1px;
        width: 20px;
        left: -10px;
      }
    }
		.show-more {
			@include palette-block;
			margin-left: 16px;
			margin-top: 0.5em;
			display: inline-block;

			.darkmode & {
				color: $white-primary;
			}
		}


		.with-icon {
			position: relative;
			.tag {
				overflow: visible;
				// background: rgb(231, 231, 231);
				// border-radius: 0 50px 50px 0;
				cursor: pointer;
				margin-left: 5px;
				&::before {
					// @include palette-block;
					position: absolute;
					content: "";
					top: 0;
					bottom: 0;
					width: 15px;
					left: 10px;
				}
			}
		}

	}
</style>